import styles from './customToggleButton.scss';

const CustomRadioButton = (props) => {

    const radioButtons = props.options.map((option, index) => (
        <span key={index}>
            <button className={styles.sceRadioStylesBtns} onClick={(e) => props.handleOptionChange(e, option)}>
                <input type='radio' id={`${props.id}-option-${index}`} name={props.name} value={option} className={`sr-only ${styles.radioInput}`}
                    checked={props.selectedOption === option} onClick={(e) => e.stopPropagation()} />
                <label htmlFor={`${props.id}-option-${index}`} className={styles.radioLabel} > {props.icons?props.icons[index]:null} {option} </label>
            </button>
        </span>
    ));
    return (
        <div className={[styles.sceRadioOutline, [props.sceToggleBorder?styles.sceRadioOutlineBorder:styles.sceRadioOutlineShadow]].join(" ")}>
            {radioButtons}
        </div>
    );
};
CustomRadioButton.defaultProps = {
    sceToggleBorder:false,
};

export default CustomRadioButton;
